export default __webpack_public_path__ + "static/media/te.84fa4ebf.pdf";